<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<div mat-dialog-content>
  <form [formGroup]="form" class="dialog-form">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>From</mat-label>
      <input matInput formControlName="from" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>To</mat-label>
      <input matInput formControlName="to" />
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Subject</mat-label>
      <input matInput formControlName="subject" />
    </mat-form-field>

    <div class="rich-text-section">
      <p class="rich-text-label">Text</p>
      <div *ngIf="!isTextEditable" class="html-preview" [innerHTML]="previewHtml"></div>
      <div
        *ngIf="isTextEditable"
        #htmlEditor
        class="html-preview html-editor"
        contenteditable="true"
        (input)="onEditorInput($event)"></div>
    </div>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Attachments</mat-label>
      <mat-select formControlName="attachments" multiple>
        <mat-option *ngFor="let attachment of data.attachments" [value]="attachment">
          {{ attachment }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="enableTextEdit()" [disabled]="isTextEditable">Change Text</button>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="send()" [disabled]="isSending">
    {{ isSending ? 'Sending...' : 'Send Mail' }}
  </button>
</div>
